import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import SwitchItemVersionCommand from '../command/switchItemVersionCommand';
import DropdownField from './dropdownField';

/**
 * @class VersionField
 */
export default class VersionField extends DropdownField {
    type = 'version';
    supports = null;

    getDropdownTemplateString() {
        return `
            <li data-item="<%= itemId %>" data-type="<%= type %>"<% if (active) { %> class="active"<% } %>>
                <a href=""<% if (!!description) { %> class="contains-description"<% } %>>
                    <span class="thumbnail">
                        <img src="<%= image %>" width="50" height="50" />
                    </span> 
                    <span class="date"><%= title %></span>
                    <% if (!!description) { %><span class="description"><%= description %></span><% } %>
                </a>
            </li>
        `;
    }

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'a', async (e) => {
            const elem = $(e.currentTarget).parent();
            const canvas = this.editor.getCanvas();
            const history = canvas.getHistory();
            const selection = canvas.getSelection();
            const item = selection.first();
            const itemFactory = canvas.getItemFactory();

            e.preventDefault();

            const attributes = {
                itemId: elem.data('item'),
                position: item.get('position').clone(),
                rotation: item.get('rotation'),
            };

            const newItem = await itemFactory.create(elem.data('type'), attributes, item.getParentItem());
            const command = new SwitchItemVersionCommand(
                item.getParentItem().getItems(),
                selection,
                [{
                    oldItem: item,
                    newItem,
                }],
            );
            history.addAndExecuteCommand(command);
        });
    }

    /**
     * Update text with item value.
     */
    updateText() {
        const activeText = this.dropdown.find('.active .date').text();
        this.button.children('.text').text(activeText);
        this.showInitialHint();
    }

    action(item, parameters) {
        if (!this.isHidden && parameters && parameters.showVersion) {
            $('.dropdown-menu', this.control).dropdown('toggle');
        }
    }

    showInitialHint() {
        if (this.selectionParameters.showInitialVersion) {
            const self = this;
            const { control } = this;
            const title = control.data('has-versions-hint');
            const link = control.children(':first');

            if (title) {
                link.tooltip('hide')
                    .tooltip('disable');

                control.tooltip('destroy')
                    .tooltip({ title, trigger: 'manual' })
                    .tooltip('show');

                link.one('click', () => {
                    self.hideInitialHint();
                });
            }
        }
    }

    hideInitialHint() {
        const { control } = this;
        const link = control.children(':first');

        link.tooltip('enable');
        control.tooltip('destroy');
    }

    show(...args) {
        this.showInitialHint();
        super.show(...args);
    }

    hide(...args) {
        this.hideInitialHint();
        super.hide(...args);
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
        const productFamily = productionDataStore.getProductFamilyForItem(item);
        const versionOptions = productFamily.getVersionOptions(item);

        this.setOptions(versionOptions);
    }

    /**
     * Update item with field value.
     */
    updateItem() {}

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        if (!(selectionLength === 1 && item && item.supportsVersions)) {
            return false;
        }

        try {
            const productionDataStore = this.editor.getCanvas().getItemFactory().getProductionDataStore();
            const productFamily = productionDataStore.getProductFamilyForItem(item);
            const versionsCount = productFamily.getVersionCount(item);

            return versionsCount > 1;
        } catch (e) {
            return false;
        }
    }
}
